import { DragSimpleTool } from './DragSimpleTool';
export default DragSimpleTool;
